import { useCallback } from 'react';
import {
  SuccessCallback,
  useActionPipeline,
  useDialogState,
  useToast,
} from 'hooks';
import { useIntl } from 'react-intl';
import { commonTexts } from 'i18n';
import { changeStatus } from 'store/scorecards';
import { SCORECARD_ACTION_ASSESSMENT_COMPLETE } from 'constants/scorecards';
import { useScorecardContext } from 'contexts';

export default function useCompleteScorecard() {
  const { id, store } = useScorecardContext();
  const [isCompleteDialogActive, openCompleteDialog, onCompleteDialogClose] =
    useDialogState();

  const onCompleteClick = useCallback(() => {
    openCompleteDialog();
  }, [openCompleteDialog]);

  const { formatMessage } = useIntl();
  const showMessage = useToast();
  const onCompleteSuccess = useCallback<SuccessCallback>(() => {
    showMessage({
      severity: 'success',
      message: formatMessage(commonTexts.success),
    });
  }, [showMessage, formatMessage]);

  const completePipeline = useActionPipeline(
    onCompleteSuccess,
    null,
    onCompleteDialogClose,
  );

  const onCompleteSubmit = useCallback(() => {
    completePipeline(
      changeStatus({ id, store, action: SCORECARD_ACTION_ASSESSMENT_COMPLETE }),
    );
  }, [completePipeline, id, store]);
  return {
    onCompleteClick,
    isCompleteDialogActive,
    onCompleteDialogClose,
    onCompleteSubmit,
  };
}
